import { Grid, IconButton, Menu, MenuItem, DialogContent, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { DateRange, Description, MoreHoriz } from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import {
  getSavedCandidatureEntreprise,
  checkIfPostuleOffer,
  postuleOffer,
  unSavedOffer,
} from '@webapps/business';
import {
  Button,
  PaginationNumbers,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedDate } from 'react-intl';
import Modal from 'components/Modal';
import { useCv } from 'pages/MyMap/Store/CvProvider';

const BusinessFavoris = ({ handleEmploiLength }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const [page, setPage] = useState(1);

  const { push } = useRouter();


  const {
    status: load,
    data: { content: savedOffers = [], totalElements } = {},
    refetch,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isFetching,
  } = useQuery(getSavedCandidatureEntreprise, {
    key: ['savedOffers', page],
    variables: { id: idUser, page: page - 1, size: 8 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    handleEmploiLength(totalElements);
  }, [totalElements]);

  const goToMyMap = () => {
    push(ROUTES_PATH.MYMAP, { params: { id: idUser } });
  };

  return (
    <div>
      <Grid
        container
        style={
          savedOffers.length === 0
            ? {
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(2.5),
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
            }
            : {
              display: 'flex',
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
              padding: spacing(2.5, 0, 0, 2.5),
              height: '100%'
            }
        }
      >
        {!savedOffers.length ? (
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              className={css({
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                padding: '30.0px',
                '@media screen and (max-width: 768px)': {
                  padding: '20px',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1
                  className={cx(css({
                    textAlign: 'center',
                    margin: '0px 0px 30px 0px',
                  }), global.title)}
                >
                  {' '}
                  Commencez à enregistrer les offres d'emploi
                </h1>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  1. Accédez à la recherche d'offres d'emploi de nos entreprises partenaires.
                </p>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  2. Triez les offres d'emploi selon vos critères de recherche et enregistrez les en un clic.
                </p>
                <p
                  style={{ textAlign: 'center', margin: '5px 5px 30px 5px' }}
                >
                  {' '}
                  3. Retrouvez facilement les offres d'emploi pour y candidatez dès que vous êtes prêt !
                </p>
                <Button
                  className={classes.btn}
                  color="primary"
                  variant="contained"
                  onClick={goToMyMap}
                  disableElevation={true}
                >
                  Rechercher des offres
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            {savedOffers.map(({ offer, applicant, saveDate }, index) => (
              <FavortieCard index={index} offer={offer} applicant={applicant} saveDate={saveDate} refetch={() => refetch()} />
            ))}
          </Grid>
        )}
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={12}
        totalCount={totalElements}
      />
    </div>
  );
};

const FavortieCard = ({offer, applicant, saveDate, index, refetch}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { addToast } = useToast();
  const { push } = useRouter();
  const [page, setPage] = useState(1);
  const { state, dispatch } = useCv();
  const [idEmploi, setIdEmploi] = useState();
  const [anchorCandid, setAnchorCandid] = useState(null);
  const [openNeedCV, setOpenNeedCV] = useState(false);
  const [tempCv, setTempCv] = useState(null);
  const [useAsDefault, setUseAsDefault] = useState(false);
  const [deleteCvTemp, setDeleteCvTemp] = useState(false);

  const openCandid = Boolean(anchorCandid);

  const handleClick = (event) => {
    setAnchorCandid(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorCandid(null);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Supprime le préfixe data
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

    if (!file || file.type !== "application/pdf") {
      addToast({
        status: 'error',
        message: "Veuillez sélectionner un fichier PDF !",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      addToast({
        status: 'error',
        message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    try {
      const base64String = await convertToBase64(file);
      setTempCv({ content: base64String, name: file.name });
      addToast({
        status: 'success',
        message: "CV chargé avec succès !",
      });
    } catch (error) {
      console.error("Erreur lors du chargement du fichier:", error);
      addToast({
        status: 'error',
        message: "Erreur lors du chargement du fichier !",
      });
    }
  };

  const handleDeleteCv = () => {

    setTempCv(null);
    setDeleteCvTemp(true);
  };

  const closeNeedCV = () => {

    setDeleteCvTemp(false);
    setTempCv(null);
    setOpenNeedCV(false);
  };

  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

  const checkFileSize = (base64String) => {
    // Calculer la taille approximative du fichier base64
    const base64Length = base64String.length;
    const fileSizeInBytes = (base64Length * 3) / 4; // Conversion approximative base64 vers taille réelle
    return fileSizeInBytes <= MAX_FILE_SIZE;
  };

  const handleSubmit = () => {
    if (tempCv) {
      if (!checkFileSize(tempCv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      if (useAsDefault) {
        dispatch({ type: "SET_CV", payload: tempCv });
        setCvNameGlobal(tempCv.name);
        setCvGlobal(tempCv.content);
      }

      postOfferWithLBA({ content: tempCv.content, name: tempCv.name });
    } else {
      if (state.cv) {
        if (!checkFileSize(state.cv)) {
          addToast({
            status: 'error',
            message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
          });
          return;
        }
        postOfferWithLBA({ content: state.cv, name: state.cvName });
      } else {
        addToast({
          status: 'error',
          message: "Aucun fichier sélectionné !",
        });
        return;
      }
    }
    closeNeedCV();
  };

  const postOfferWithLBA = async (cv) => {
    try {
      if (!checkFileSize(cv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      const postuleOfferAPILBA = await fetch(`${process.env.NX_LBA_URL}/job/v1/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + process.env.NX_LBA_API_TOKEN,
        },
        body: JSON.stringify({
          applicant_first_name: applicant?.firstname,
          applicant_last_name: applicant?.lastname,
          applicant_email: applicant?.email,
          applicant_phone: applicant?.phone,
          applicant_attachment_name: cv.name,
          applicant_attachment_content: cv.content,
          recipient_id: offer?.idLaBonneAlternance,
          applicant_message: null
        }),
      });

      const postuleOfferAPILBAJson = await postuleOfferAPILBA.json();

      await mutatePostuleOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: info?.id,
          },
          fromLaBonneAlternance: true
        },
      });
    } catch (error) {
      console.error("error postuleOfferAPILBA : ", error);
      addToast({
        status: 'error',
        message: "Erreur lors de l'envoi du CV",
      });
    }
  };

  const goToBusiness = (idBusiness) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id: idBusiness } });
  };

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleOffer,
    {
      key: ['checkPostuleOffer'] + idUser + offer?.id,
      variables: { idApplicant: idUser, idOffer: offer?.id },
    }
  );

  const {
    isLoading: isLoadingPostuleOffer,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleOffer,
  } = useMutation(postuleOffer);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteSavedOffer,
  } = useMutation(unSavedOffer);

  const postOffer = async ({ offer }) => {
    setIdEmploi(offer?.id);
    if (offer?.idLaBonneAlternance) {

      setOpenNeedCV(true);
      return;

    } else {
      await mutatePostuleOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: offer?.id,
          },
        },
      });
    }
  };

  const deleteSavedOffer = async ({ idOffer }) => {
    await mutateDeleteSavedOffer({
      idApplicant: idUser,
      idOffer: idOffer,
    });
  };

  useEffect(async () => {
    if (isSuccessPostule) {
      await mutateDeleteSavedOffer({
        idApplicant: idUser,
        idOffer: idEmploi,
      });
      refetchPostule();
      refetch();
    }
  }, [isSuccessPostule]);

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
    }
    refetchPostule();
    refetch();
  }, [isSuccessDelete]);

  return (
    <Grid
      item
      xs={12}
      md={4}
      lg={3}
      key={index}
      style={{ padding: spacing(0, 2.5, 2.5, 0) }}
    >
      <Grid
        item
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          borderRadius: 10,
          padding: spacing(2.5),
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            // backgroundColor: 'red'
          })}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <AvatarCompany
                height={60}
                idCompany={offer?.business?.id}
                name={offer?.shcool?.name}
                variant="circular"
                width={60}
              />
              <div style={{ display: 'flex', marginLeft: "8px", flexDirection: 'column', justifyContent: 'center' }}>
                <div className={cx(global.title, classes.block)}> {offer?.job?.label} </div>
                <div className={cx(global.infoText, classes.name)}>
                  <div style={{marginRight: '8px'}}>{offer?.business?.name || offer?.businessExternal?.name || offer?.businessLaBonneAlternance?.name}</div>
                  {offer?.business?.name ? (
                    <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                    ) : (
                      <div style={{color: "white", backgroundColor: '#152652', borderRadius: '6px', padding: '1px 5px', fontWeight: 600}}>Externe</div>
                    )}
                </div>
              </div>
            </div>
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={openCandid ? 'candidature-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openCandid ? 'true' : undefined}
              style={{
                // margin: '0px 3px',
                alignSelf: 'baseline',
                borderRadius: '20px',
                border: '1px solid #C0D9FF',
                backgroundColor: '#F3F7FF',
                width: '26px',
                display: 'flex',
                justifyContent: 'center',
                height: '26px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
            </IconButton>
          </div>

          <div className={classes.divInfos}>
            <div className={cx(global.infoText, classes.address)}>
              <Description className={global.infoIcon} />
              {offer?.contractType?.label}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <RoomIcon className={global.infoIcon} />
              {offer?.business?.address?.cityCode || offer?.businessExternal?.address?.cityCode || offer?.businessLaBonneAlternance?.address?.cityCode}{' '}
              {offer?.business?.address?.city || offer?.businessExternal?.address?.city || offer?.businessLaBonneAlternance?.address?.city}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <DateRange className={global.infoIcon} />
              Candidature du{' '}
              <FormattedDate
                day="numeric"
                month="numeric"
                value={offer.createdAt}
                year="numeric"
              />{' '}
              au{' '}
              <FormattedDate
                day="numeric"
                month="numeric"
                value={offer.deadLine}
                year="numeric"
              />
            </div>
          </div>
          <div className={css({ display: 'flex', marginTop: spacing(2), alignItems: 'center' })}>
            {checkPostule ? (
              <Button
                disabled
                variant="outlined"
              >
                Déjà postulé
              </Button>
            ) : (
              <Button
                color="primary"
                disabled={isLoadingPostuleOffer}
                onClick={() => postOffer({ offer })}
                variant="contained"
              >
                Postuler
              </Button>
            )}
          </div>
        </div>
        <Menu
          anchorEl={anchorCandid}
          id="candidature-menu"
          open={openCandid}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{ elevation: 2 }}
          transformOrigin={{ horizontal: 'left', vertical: -50 }}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          {offer?.business && (
            <MenuItem
              disableRipple
              disableFocusRipple
              onClick={() => goToBusiness(offer?.business?.id)}
            >
              Voir la vitrine
            </MenuItem>
          )}
          {/* <MenuItem>
      <Link className={css({ textDecoration: 'none', display: 'flex', alignItems: 'center', color: '#000000DE' })}
        to='#'>
        Voir l'annonce
      </Link></MenuItem> */}
          <MenuItem
            disableRipple
            disableFocusRipple
            onClick={() => deleteSavedOffer({ idOffer: offer.id })}
          >
            Retirer des favoris
          </MenuItem>
        </Menu>
      </Grid>
      <Modal open={openNeedCV} onCancel={closeNeedCV}
        title="Envoyer votre CV"
      >
        <DialogContent className={classes.modalContent}>
          <Typography className={global.title} style={{ textAlign: "center" }}>Vous avez besoin de votre CV pour postuler à cette offre.</Typography>
          {deleteCvTemp ? <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} />
            : state.cv ?  (
              // 
              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <Typography className={global.subTitle}>{tempCv?.name || state.cvName || "Aucun fichier sélectionné"}</Typography>
                <IconButton onClick={handleDeleteCv} color="secondary">
                  <Delete />
                </IconButton>
              </div>
            ) : <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} /> }

          {tempCv && (
            <FormControlLabel
              control={<Checkbox checked={useAsDefault} onChange={() => setUseAsDefault(!useAsDefault)} />}
              label="Utiliser ce CV par défaut"
            />
          )}

          <Button onClick={handleSubmit} color="primary" variant="contained" className={classes.candidateButton}>
            Postuler
          </Button>
        </DialogContent>
      </Modal >
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: spacing(3),
    borderRadius: 10,
    border: '1px solid #E8E8E8',
    marginTop: spacing(3),
    '&:first-child': { marginTop: 0 },
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    height: 50,
    width: 50,
  },
  name: {
    color: '#152652',
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
  block: {
    display: 'flex',
    width: '100%',
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noElement: {
    lineHeight: '110%',
  },
  divInfos: {
    marginTop: spacing(1),
    '@media only screen and (max-width:768px)': {
      margin: 0,
    },
  },
});

export default BusinessFavoris;
